export default function Order(state = {}, action) {
  switch (action.type) {
    case 'SET_ORDER':
      return {
        ...state,
        ...action.order
      };
    case 'UPDATE_ORDER_SUMMARY': {
      return {
        ...state,
        orderSummary: action.orderSummary
      };
    }
    default:
      return state;
  }
}
